import { ethers } from 'ethers'

// ============ 支持的钱包列表 ============
export const SUPPORTED_WALLETS = [
  { id: 'metamask',     name: 'MetaMask',      icon: '🦊', check: () => window.ethereum?.isMetaMask },
  { id: 'okx',         name: 'OKX Wallet',    icon: '⭕', check: () => !!window.okxwallet },
  { id: 'binance',     name: 'Binance Web3',  icon: '🟡', check: () => !!window.BinanceChain },
  { id: 'tokenpocket', name: 'TokenPocket',   icon: '💳', check: () => !!window.tokenpocket },
  { id: 'trust',       name: 'Trust Wallet',  icon: '🛡️', check: () => !!window.trustwallet },
  { id: 'imtoken',     name: 'imToken',       icon: '💎', check: () => !!window.imToken },
]


export const LIQUIDITY_PREDICTION_ABI = [
  // 常量查询
  'function MIN_USDT() external view returns (uint256)',
  'function MAX_USDT() external view returns (uint256)',
  'function MULTIPLY_10() external view returns (uint8)',
  'function MULTIPLY_30() external view returns (uint8)',
  'function MULTIPLY_100() external view returns (uint8)',
  'function STAKE_RATIO() external view returns (uint256)',
  'function INCENTIVE_RATIO() external view returns (uint256)',
  'function getMinUsdt() external pure returns (uint256)',
  'function getMaxUsdt() external pure returns (uint256)',
  'function getMultiply10() external pure returns (uint8)',
  'function getMultiply30() external pure returns (uint8)',
  'function getMultiply100() external pure returns (uint8)',
  'function getStakeRatio() external pure returns (uint256)',
  'function getIncentiveRatio() external pure returns (uint256)',
  'function getConstants() external pure returns (uint256 minUsdt, uint256 maxUsdt, uint8 multiply10, uint8 multiply30, uint8 multiply100, uint256 stakeRatio, uint256 incentiveRatio)',

  // 状态变量
  'function usdtToken() external view returns (address)',
  'function ukToken() external view returns (address)',
  'function router() external view returns (address)',
  'function signer() external view returns (address)',
  'function stakeCount() external view returns (uint256)',
  'function withdrawNonce(address) external view returns (uint256)',

  // 质押记录查询
  'function stakeRecords(uint256) external view returns (uint256 id, address user, uint256 usdtAmount, uint8 multiply, uint256 stakedUK, uint256 incentiveUK, uint256 entryPrice, uint256 targetPrice, bool forceSold, uint256 joinTime)',
  'function getUserStakeIds(address) external view returns (uint256[])',
  'function getStakeRecord(uint256) external view returns (tuple(uint256 id, address user, uint256 usdtAmount, uint8 multiply, uint256 stakedUK, uint256 incentiveUK, uint256 entryPrice, uint256 targetPrice, bool forceSold, uint256 joinTime))',
  'function getStakeRecords(uint256[]) external view returns (tuple(uint256 id, address user, uint256 usdtAmount, uint8 multiply, uint256 stakedUK, uint256 incentiveUK, uint256 entryPrice, uint256 targetPrice, bool forceSold, uint256 joinTime)[])',

  // 余额查询
  'function ukBalance() external view returns (uint256)',
  'function usdtBalance() external view returns (uint256)',

  // 主要功能
  'function joinPrediction(uint256 usdtAmount, uint8 multiply, uint256 entryPrice, uint256 minUKOut) external',
  'function forceSell(uint256 stakeId, uint256 minUSDTOut) external',
  'function withdrawUK(uint256 amount, uint256 nonce, uint256 deadline, uint8 withdrawType, bytes calldata signature) external',

  // Owner功能
  'function setSigner(address) external',
  'function withdrawUSDT(address to, uint256 amount) external',
  'function recoverUK(address to, uint256 amount) external',
  'function transferUKToPool(address to, uint256 amount) external',

  // 事件
  'event PredictionJoined(uint256 indexed stakeId, address indexed user, uint256 usdtAmount, uint8 multiply, uint256 stakedUK, uint256 incentiveUK, uint256 joinTime)',
  'event ForceSold(uint256 indexed stakeId, address indexed user, uint256 ukAmount, uint256 usdtReceived)',
  'event UKWithdrawn(address indexed user, uint256 amount, uint256 nonce)',
  'event SignerUpdated(address newSigner)',
  'event USDTWithdrawn(address indexed to, uint256 amount)',
  'event UKRecovered(address indexed to, uint256 amount)'
]

// ============ PancakeSwap V2 Router ABI（前端需要的方法）============
// PancakeSwap V2 Router
export const PANCAKE_ROUTER_ABI = [
  'function factory() external view returns (address)',
  'function WETH() external view returns (address)',
  'function getAmountsOut(uint amountIn, address[] calldata path) external view returns (uint[] memory amounts)',
  'function getAmountsIn(uint amountOut, address[] calldata path) external view returns (uint[] memory amounts)',
  'function swapExactTokensForTokensSupportingFeeOnTransferTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external',
  'function swapExactTokensForTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)',
  'function swapTokensForExactTokens(uint amountOut, uint amountInMax, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)',
  'function addLiquidity(address tokenA, address tokenB, uint amountADesired, uint amountBDesired, uint amountAMin, uint amountBMin, address to, uint deadline) external returns (uint amountA, uint amountB, uint liquidity)'
]

// PancakeSwap V2 Pair
export const PANCAKE_PAIR_ABI = [
  'function getReserves() external view returns (uint112 reserve0, uint112 reserve1, uint32 blockTimestampLast)',
  'function token0() external view returns (address)',
  'function token1() external view returns (address)',
  'function totalSupply() external view returns (uint256)',
  'function balanceOf(address) external view returns (uint256)',
  'function sync() external'
]

// USDT ABI
export const USDT_ABI = [
  'function name() external view returns (string)',
  'function symbol() external view returns (string)',
  'function decimals() external view returns (uint8)',
  'function totalSupply() external view returns (uint256)',
  'function balanceOf(address) external view returns (uint256)',
  'function allowance(address owner, address spender) external view returns (uint256)',
  'function approve(address spender, uint256 amount) external returns (bool)',
  'function transfer(address to, uint256 amount) external returns (bool)',
  'function transferFrom(address from, address to, uint256 amount) external returns (bool)'
]


// UK Token ABI
export const UK_TOKEN_ABI = [
  // ERC20标准方法
  'function name() external view returns (string)',
  'function symbol() external view returns (string)',
  'function decimals() external view returns (uint8)',
  'function totalSupply() external view returns (uint256)',
  'function balanceOf(address) external view returns (uint256)',
  'function allowance(address owner, address spender) external view returns (uint256)',
  'function approve(address spender, uint256 amount) external returns (bool)',
  'function transfer(address to, uint256 amount) external returns (bool)',
  'function transferFrom(address from, address to, uint256 amount) external returns (bool)',

  // 常量查询
  'function TOTAL_SUPPLY() external pure returns (uint256)',
  'function MIN_SUPPLY() external pure returns (uint256)',
  'function NODE_ALLOCATION() external pure returns (uint256)',
  'function LIQUIDITY_ALLOCATION() external pure returns (uint256)',
  'function TAX_NODE() external pure returns (uint256)',
  'function TAX_BURN() external pure returns (uint256)',
  'function TAX_ECO() external pure returns (uint256)',
  'function TAX_FOUNDATION() external pure returns (uint256)',
  'function TAX_TOTAL() external pure returns (uint256)',
  'function getTaxConstants() external pure returns (uint256 taxNode, uint256 taxBurn, uint256 taxEco, uint256 taxFoundation, uint256 taxTotal)',
  'function getSupplyConstants() external pure returns (uint256 totalSupply_, uint256 minSupply, uint256 nodeAllocation, uint256 liquidityAllocation)',

   // ✅ 新增：买入开关状态
   'function CAN_BUY() external view returns (bool)',
   
  // 状态变量
  'function nodePool() external view returns (address)',
  'function ecoPool() external view returns (address)',
  'function foundation() external view returns (address)',
  'function totalBurned() external view returns (uint256)',
  'function isExempt(address) external view returns (bool)',
  'function isPair(address) external view returns (bool)',

  // Owner配置功能
  'function setPair(address pair, bool status) external',
  'function setExempt(address account, bool status) external',
  'function updatePools(address _nodePool, address _ecoPool, address _foundation) external',

  // 燃烧功能
  'function autoBurn(address pairAddress) external',
  'function fuseBurn(address pairAddress) external',
  'function manualBurn(uint256 amount, address pairAddress) external',

  // 事件
  'event TaxDistributed(address indexed from, uint256 nodeAmt, uint256 burnAmt, uint256 ecoAmt, uint256 foundationAmt)',
  'event AutoBurn(uint256 amount, uint256 newTotalSupply)',
  'event FuseBurn(uint256 amount, uint256 newTotalSupply)',
  'event PairSet(address pair, bool status)',
  'event ExemptSet(address account, bool status)',
  'event PoolsUpdated(address nodePool, address ecoPool, address foundation)'
]


// Node Manager ABI - 匹配实际合约
export const NODE_ABI = [
  // 常量查询
  'function NODE_PRICE_USDT() external view returns (uint256)',
  'function getNodePriceUsdt() external pure returns (uint256)',
  'function getNodeUkAmount() external pure returns (uint256)',
  'function getMaxNodes() external pure returns (uint256)',
  'function getTotalNodeUk() external pure returns (uint256)',
  'function getConstants() external pure returns (uint256 nodePriceUsdt, uint256 nodeUkAmount, uint256 maxNodes, uint256 totalNodeUk)',

  // 状态变量
  'function usdtToken() external view returns (address)',
  'function ukToken() external view returns (address)',
  'function signer() external view returns (address)',
  'function nodeCount() external view returns (uint256)',
  'function withdrawNonce(address) external view returns (uint256)',
  'function holderCount() external view returns (uint256)',
  'function salePaused() external view returns (bool)',

  // 节点信息查询
  'function nodeInfoOf(address) external view returns (bool isNode, uint256 joinTime, uint256 paidUsdt, uint256 totalUK, uint256 claimedUK, uint256 ownedNodes)',
  'function claimableUK(address) external view returns (uint256 claimed, uint256 total)',
  'function ukBalance() external view returns (uint256)',
  'function getNodeHolders(uint256 offset, uint256 limit) external view returns (address[] memory holders, uint256 total)',
  'function getNodeInfoBatch(address[]) external view returns (tuple(bool isNode, uint256 joinTime, uint256 paidUsdt, uint256 totalUK, uint256 claimedUK, uint256 ownedNodes)[])',

  // 主要功能
  'function joinNode(uint256 count) external',
  'function distributeDividend(uint256 amount) external',
  'function withdrawUK(uint256 amount, uint256 nonce, uint256 deadline, bytes calldata signature) external',

  // Owner功能
  'function setUKToken(address) external',
  'function setSigner(address) external',
  'function withdrawUSDT(address to, uint256 amount) external',
  'function recoverUK(address to, uint256 amount) external',

  // 事件
  'event NodeJoined(address indexed user, uint256 nodesBought, uint256 totalPaidUsdt, uint256 timestamp)',
  'event UKWithdrawn(address indexed user, uint256 amount, uint256 nonce)',
  'event DividendDistributed(uint256 totalAmount, uint256 totalNodes, uint256 holderCount)',
  'event DividendSent(address indexed holder, uint256 amount)',
  'event DividendFailed(address indexed holder, uint256 amount)',
  'event SignerUpdated(address newSigner)',
  'event USDTWithdrawn(address indexed to, uint256 amount)',
  'event UKRecovered(address indexed to, uint256 amount)'
]



// ============ 网络配置 ============
export const NETWORKS = {
  56: {
    name:       'BSC Mainnet',
    chainId:    '0x38',
    rpcUrls:    ['https://bsc-dataseed1.binance.org/'],
    explorer:   'https://bscscan.com',
    pancakeRouter:  '0x10ED43C718714eb63d5aA57B78B54704E256024E',
    pancakeFactory: '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73',
    usdt:           '0x55d398326f99059fF775485246999027B3197955',
  },
  97: {
    name:       'BSC Testnet',
    chainId:    '0x61',
    rpcUrls:    ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
    explorer:   'https://testnet.bscscan.com',
    pancakeRouter:  '0xD99D1c33F9fC3444f8101754aBC46c52416550D1',
    pancakeFactory: '0x6725F303b657a9451d8BA641348b6761A6CC7a17',
    usdt:           '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd',
  }
}

// ============ 钱包连接 ============
export function getProvider(walletId) {
  switch (walletId) {
    case 'okx':         return window.okxwallet
    case 'binance':     return window.BinanceChain
    case 'tokenpocket': return window.tokenpocket?.ethereum || window.ethereum
    case 'trust':       return window.trustwallet           || window.ethereum
    case 'imtoken':     return window.imToken               || window.ethereum
    default:            return window.ethereum
  }
}

export async function connectWallet(walletId) {
  const providerRaw = getProvider(walletId)

  if (!providerRaw) {
    throw new Error(`请先安装 ${walletId}`)
  }

  // 请求钱包连接
  const accounts = await providerRaw.request({
    method: 'eth_requestAccounts'
  })

  if (!accounts.length) {
    throw new Error('No accounts found')
  }

  // ethers v5: 使用 Web3Provider 而不是 BrowserProvider
  const provider = new ethers.providers.Web3Provider(providerRaw)

  console.log("333333333333", provider, accounts[0])

  return {
    provider,           // ethers v5 provider
    address: accounts[0].toLowerCase(),
    providerRaw
  }
}

export async function signMessage(signer, message) {
  // ethers v5: signMessage 用法相同
  const signature = await signer.signMessage(message)
  return signature
}


// ============ 切换到BSC网络 ============
export async function switchToBSC(rawProvider, chainId = 56) {
  const network = NETWORKS[chainId]

  try {
    await rawProvider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: network.chainId }]
    })
  } catch (err) {

    if (err.code === 4902) {
      await rawProvider.request({
        method: "wallet_addEthereumChain",
        params: [{
          chainId: network.chainId,
          chainName: network.name,
          nativeCurrency: {
            name: "BNB",
            symbol: "BNB",
            decimals: 18
          },
          rpcUrls: network.rpcUrls,
          blockExplorerUrls: [network.explorer]
        }]
      })
    } else {
      throw err
    }
  }
}

// ============ 工具函数 ============
export function formatUnits(value, decimals = 18) {
  // ethers v5: 使用 utils.formatUnits
  return ethers.utils.formatUnits(value, decimals)
}

export function parseUnits(value, decimals = 18) {
  // ethers v5: 使用 utils.parseUnits
  return ethers.utils.parseUnits(String(value), decimals)
}

export function formatAddress(addr) {
  if (!addr) return ''
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`
}

// 从PancakeSwap LP Pair计算实时价格
export async function getPriceFromPair(pairContract, ukAddress) {
  try {
    const [reserve0, reserve1] = await pairContract.getReserves()
    const token0 = await pairContract.token0()
    const isUKToken0 = token0.toLowerCase() === ukAddress.toLowerCase()

    // reserve单位不同（UK=18位，USDT=18位on BSC）
    const ukReserve   = isUKToken0 ? reserve0 : reserve1
    const usdtReserve = isUKToken0 ? reserve1 : reserve0

    if (ukReserve === 0n) return 0

    // price = usdtReserve / ukReserve
    const price = Number(ethers.formatUnits(usdtReserve, 18)) /
                  Number(ethers.formatUnits(ukReserve, 18))
    return price
  } catch {
    return 0
  }
}

// 从PancakeSwap Router预估买入UK数量
export async function estimateBuyUK(
  routerContract,
  usdtAmount,
  usdtAddress,
  ukAddress,
  decimals = 18
) {
  try {
    const amountIn = parseUnits(String(usdtAmount), decimals)
    const amounts  = await routerContract.getAmountsOut(
      amountIn,
      [usdtAddress, ukAddress]
    )
    return parseFloat(formatUnits(amounts[1], 18))
  } catch {
    return 0
  }
}

// 从PancakeSwap Router预估卖出获得USDT
export async function estimateSellUSDT(
  routerContract,
  ukAmount,
  ukAddress,
  usdtAddress,
  decimals = 18
) {
  try {
    const amountIn = parseUnits(String(ukAmount), 18)
    const amounts  = await routerContract.getAmountsOut(
      amountIn,
      [ukAddress, usdtAddress]
    )
    return parseFloat(formatUnits(amounts[1], decimals))
  } catch {
    return 0
  }
}
